export enum PropertyAreaUnitEnum {
    /**
    * Hectares.
    */
    Hectares = 1,
    /**
    * Acres.
    */
    Acres = 2,
}